<div class="auth-wrapper">
  <div class="auth-content">
    <div class="auth-bg">
      <span class="r"></span>
      <span class="r s"></span>
      <span class="r s"></span>
      <span class="r"></span>
    </div>
    <div class="card">
      <!-- background-color: #BC5C1C; -->
      <div class="card-body text-center">
        <div class="">
          <img src="/assets/logo2.png" alt="company logo" width="200px" style=" padding:10px; border-radius: 10px;">
        </div>
        @if (step===1) {

                <h4 class="mb-4">Reset Password</h4>
                <form [formGroup]="loginForm" (ngSubmit)="submit()">
                  <div class="d-flex justify-content-start">
                    <label for="email" class="text-start mb-1 fw-900">Registered Email: </label>
                  </div>
                  <div class="input-group mb-3">
                    <input type="email" name="email" class="form-control" placeholder="Email" formControlName="email" />
                  </div>
                  <button class="btn btn-sm btn-primary mb-4" type="submit" [disabled]="!this.loginForm.valid">Send OTP</button>
                </form>
              }

              @if (step===2) {

                <h4 class="mb-4">Enter OTP</h4>
                <form [formGroup]="otpForm" (ngSubmit)="submit()">
                 <div class="otp-container mb-4">
                    <input
                      type="text"
                      maxlength="1"
                      formControlName="otp0"
                      (input)="moveToNext($event, 0)"
                      #otp0
                      class="form-control"
                    />
                    <input
                      type="text"
                      maxlength="1"
                      formControlName="otp1"
                      (input)="moveToNext($event, 1)"
                      #otp1
                      class="form-control"
                    />
                    <input
                      type="text"
                      maxlength="1"
                      formControlName="otp2"
                      (input)="moveToNext($event, 2)"
                      #otp2
                      class="form-control"
                    />
                    <input
                      type="text"
                      maxlength="1"
                      formControlName="otp3"
                      (input)="moveToNext($event, 3)"
                      #otp3
                      class="form-control"
                    />
                  </div>


                  <button class="btn btn-sm btn-primary mb-4" type="button" (click)="verifyOTP()" [disabled]="!this.otpForm.valid">Verfy OTP</button>
                </form>
              }

              @if(step===3) {
                <h4 class="mb-4">Forgot Password</h4>
                <form [formGroup]="newPasswordForm" (ngSubmit)="forgotPassword()">
                  <div class="d-flex justify-content-start">
                    <label for="email" class="text-start mb-1 fw-900">New Password: </label>
                  </div>
                  <div class="input-group mb-1">
                    <input [type]="showPassword" name="email" class="form-control" placeholder="Type here" formControlName="password" />
                  </div>
                  <div class="d-flex justify-content-end text-primary" (click)="toggleShowPassword(showPassword)">{{showPassword==='text'?'Hide':'Show'}}</div>
                  <button class="btn btn-sm btn-primary mb-4" type="submit" [disabled]="!this.newPasswordForm.valid">Submit</button>
                </form>
              }
              <p class="mb-2 text-muted">
                Already Know Password?
                <a [routerLink]="['/login']">Login</a>
              </p>
      </div>
    </div>
  </div>
</div>
